import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import listText from "../utils/dictionaries/dictionary-identity-validation";
import Image from "../components/atoms/image";
import Paragraph from "../components/atoms/paragraph";
import Button from "../components/atoms/button";
import Top from "../components/templates/top";
import Link from "../components/atoms/link";
import ic_selfie_blue from "../assets/icons/ic_selfie_blue.svg";
import ic_face_retouching_natural from "../assets/icons/ic_face_retouching_natural.svg";
import ic_no_sunglasses_blue from "../assets/icons/ic_no_sunglasses_blue.svg";
import ic_document_id_blue from "../assets/icons/ic_document_id_blue.svg";
import Loader from "../components/atoms/loader";
import { store } from "../redux/store";
import { changeNavigate } from "../redux/slices/navigateReducer";
import { useDispatch } from "react-redux";
import { BiometricValidation } from "../../application/use-cases/biometric-validation.usecase";
import ProcessContracts from "../services/processContracts.service";

const IdentityValidation = () => {
  const dispatch = useDispatch();
  const [, setSec] = useState<number>(0);
  const [toggle] = useState<boolean>(false);
  const ref = useRef<NodeJS.Timeout | null>(null);
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(false);
  const [biometricIneStatus, setBiometricIneStatus] = useState("");
  const state = store.getState();
  const getBiometricIneData = new ProcessContracts();
  const useCaseGetBiometricIne = new BiometricValidation(getBiometricIneData);
  const [retries, setRetries] = useState<any>();

  const getBiometricIne = async () => {
    const response = await useCaseGetBiometricIne.getBiometricIne(state.client.clientPersist.uuid)
    setBiometricIneStatus(response.data.status)
    setRetries(response.data.retries)
  };

  useEffect(() => {
    ref.current = setInterval(() => {
      if (toggle) setSec((state) => state + 1);

      if (localStorage.getItem("conditionLiveness") == "false" && biometricIneStatus !== null) {
        navigate("/LivenessCheck");
        localStorage.setItem("biometricValidation", biometricIneStatus);
        localStorage.setItem("retries", retries);
      }
    });

    return () => {
      if (ref.current) clearInterval(ref.current);
    };
  }, [toggle, biometricIneStatus, retries]);

  useEffect(() => {
    getBiometricIne()
  }, []);

  const next = async () => {
    dispatch(
      changeNavigate({
        progressBarPercentage: "90%",
        editableValue: state.client.dataPersist.phone,
        typeValue: "phone",
        textButton: "Continuar",
        nextContinue: "/VideoCaptureCondition",
        comeFrom: "IdentityValidation",
        isReturn: true,
      }),
    );
    navigate("/ValidateCode");
  };

  const followLaterAction = () => {
    navigate("/FollowLater", {
      state: {
        resource: "/IdentityValidation",
        step: "CONTINUE_AFTER",
        data: state.client.dataPersist,
      },
    });
  };

  if (showLoader) {
    return <Loader />;
  }

  return (
    <>
      <div className="content-container">
        <Top
          titleHeader={listText.text_1.mainText}
          subTitle={listText.text_2.mainText}
          displayProgressBar={""}
          displayLeftImageTitle={"d-none"}
          classTitleImage={""}
          classHeader={"mt-2"}
          styleHeader={{}}
          classProgressBar={"mt-3"}
          styleProgressBar={{}}
          classTitleAndImage={""}
          styleTitleAndImage={{}}
          valueProgressBar={"90%"}
          comeFrom={"/IdentityValidation"}
          onClickGoBackIcon={() => navigate("/")}
        />
        <div className="p-3">
          <div className="text-center mb-4_3 mt-4">
            <Image
              srcImage={ic_selfie_blue}
              className={"ic_selfie_blue"}
              alt={""}
              dataBsDismiss={""}
              styleImg={undefined}
              onClick={undefined}
            ></Image>
          </div>
          <div className="col-12 mb-4_9">
            <Paragraph
              text={listText.text_3.mainText}
              className={"fs-7 mb-0 lh-base dark-blue-title"}
              styleParagraph={undefined}
            />
          </div>
          <div className="d-flex align-items-center pb-3">
            <div className="col-1">
              <Image
                srcImage={ic_face_retouching_natural}
                className={"h-32 w-32"}
                alt={""}
                dataBsDismiss={""}
                styleImg={undefined}
                onClick={undefined}
              ></Image>
            </div>
            <div className="col-11 mt-2">
              <Paragraph
                text={listText.text_4.mainText}
                className={"fs-7 mb-0 lh-base ms-3 dark-blue-title"}
                styleParagraph={undefined}
              />
            </div>
          </div>
          <div className="d-flex align-items-center pb-3">
            <div className="col-1">
              <Image
                srcImage={ic_no_sunglasses_blue}
                className={"h-32 w-32"}
                alt={""}
                dataBsDismiss={""}
                styleImg={undefined}
                onClick={undefined}
              ></Image>
            </div>
            <div className="col-11 mt-2">
              <Paragraph
                text={listText.text_5.mainText}
                className={"fs-7 mb-0 lh-base ms-3 dark-blue-title"}
                styleParagraph={undefined}
              />
            </div>
          </div>
          <div className="d-flex align-items-center mb-4_9">
            <div className="col-1">
              <Image
                srcImage={ic_document_id_blue}
                className={"h-32 w-32"}
                alt={""}
                dataBsDismiss={""}
                styleImg={undefined}
                onClick={undefined}
              ></Image>
            </div>
            <div className="col-11 mt-2">
              <Paragraph
                text={listText.text_6.mainText}
                className={"fs-7 mb-0 lh-base ms-3 dark-blue-title"}
                styleParagraph={undefined}
              />
            </div>
          </div>
          <div className="d-flex align-items-center mb-4_9">
            <div className="col-12">
              <Paragraph
                text={listText.text_7.mainText}
                className={"fs-7 mb-0 lh-base light-gray-500"}
                styleParagraph={undefined}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="footer--pin">
        <Button
          id={""}
          text={listText.text_8.mainText}
          divClassName={""}
          buttonClassName={"btn-bg-primary text-white w-100 place-content-center align-self-center"}
          spinner={false}
          onClick={() => next()}
          disabled={false}
          dataBsDismiss={""}
        ></Button>

        <div className="text-center mt-3">
          <Link
            text={listText.text_9.mainText}
            url={null}
            styleLink={{
              color: "#5A6172",
              lineHeight: "16px",
              textDecoration: "none",
              cursor: "pointer",
            }}
            onClick={() => followLaterAction()}
            className={""}
          />
        </div>
      </div>
    </>
  );
};

export default IdentityValidation;
